<template>
  <v-select
    :label="$t('ReceiptBillAnalyze.billTypes.title')"
    v-model="model"
    :items="billTypes"
  ></v-select>
</template>

<script>
import consts from "@/consts.js";

export default {
  name: "SearcherSupplyType",
  props: {
    value: Number,
    objType: Number,
    Select: Boolean,
  },
  computed: {
    billTypes() {
      var items = [];
      if (this.Select) {
        if (this.objType == 1) {
          items =  consts.billTypes;
        } else {
          items = consts.purchaseBillTypes;
        }
      }else{
        items = consts.BillTypes;
      }
      return items;
    },
  },

  data: () => ({
    model: null,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      handler() {
        this.$emit("input", this.model);
      },
    },
  },
};
</script>
